/**
 * media 配图提前预取（2026-10-29 §3.4cm 批 1-D4）
 *
 * 目的：微博/新闻卡的配图在卡打开**之前**就把字节拉进 HTTP 缓存，卡打开时 img.src 直接命中，
 * 不再从零请求（当前库里只有 1 张配图，收益有限；价值在机制就位，此后新增配图自动吃预取）。
 *
 * 三条口径：
 *  - 必须消费响应体（`.blob()`）：不读 body 时浏览器可能丢弃内容、不落 HTTP 缓存，img.src 会再发一次。
 *  - URL 原样用相对串（`media/x.webp`），⛔ 拼 `location.origin`：PWA 从 index.html 打开时会与
 *    `img.src` 解析出不同 URL，缓存键不一致，预取白做。
 *  - 失败静默吞掉（配图缺失本就由 `onerror` 藏图），不 console、不抛。
 *
 * 本模块只依赖 fetch，⛔ import 任何面板/演出模块（保持单向依赖）。
 */
const seen = new Set<string>();

/** 低优先级预取一张配图；同一 URL 会话内只发一次 */
export function prefetchMediaImage(url: string | undefined): void {
    if (!url || seen.has(url)) return;
    seen.add(url);
    fetch(url, { priority: 'low' })
        .then(r => r.blob())
        .then(() => {})
        .catch(() => {});
}

/** 通用别名：任意「晚点要用」的图片都可以先这样把字节拉进 HTTP 缓存（与配图共用同一条 seen 账） */
export const prefetchImageBytes = prefetchMediaImage;